<div fxLayout="row"
     fxLayoutAlign="start center">
  <h1 fxFlex matDialogTitle>LOGIN</h1>
  <ui-alerts-button></ui-alerts-button>
</div>
<form (ngSubmit)="loginSubmit()" #loginForm="ngForm" fxLayout="column">
  <mat-dialog-content fxLayout="column">
    <div class="alert" *ngIf="errorMsg">{{errorMsg.msg}}</div>
    <mat-form-field>
      <mat-label>User Name</mat-label>
      <input
        uiAutoFocus
        matInput
        id="login-username"
        name="username"
        #usernameModel="ngModel"
        [(ngModel)]="username"
        [disabled]="busy"
        required
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Password</mat-label>
      <input
        matInput
        id="login-password"
        type="password"
        name="password"
        #passwordModel="ngModel"
        [disabled]="busy"
        [(ngModel)]="password"
        required
      />
    </mat-form-field>

  </mat-dialog-content>

  <mat-dialog-actions fxLayoutGap="10px" fxLayoutAlign="end">
    <button type="button" mat-raised-button (click)="cancel()" [disabled]="busy">Cancel</button>
    <button type="submit" mat-raised-button color="primary" [disabled]="!loginForm.form.valid || busy">Login</button>
  </mat-dialog-actions>

</form>

<div *ngIf="!isReleaseBuild" class="test-alert">Your password for accessing the Messenger+ test environment may be different from your Production system password.</div>
<div class="test-alert">For login assistance or to request access, please contact Customer Support.</div>
